import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=c948892a&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=ts"
export * from "./SidebarNav.vue?vue&type=script&lang=ts"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=c948892a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c948892a",
  null
  
)

export default component.exports